import axios from "axios";
import { districtNameById } from "views/Forms/FulfillmentPartner/partnerFormUtils";
const adminHeaders = (token) => ({
  "Content-Type": "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: "Bearer " + token,
});

export const getAdminPickupOrders = (params, token) => {
  const queryParams = Object.keys(params || {}).reduce((query, key) => {
    const value = params[key];

    if (value !== "" && value !== null && value !== undefined) {
      query[key] = value;
    }

    return query;
  }, {});

  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/admin/pickup-order", {
      params: queryParams,
      headers: adminHeaders(token),
    })
    .then((res) => res.data);
};

export const updateAdminPickupOrderStatuses = (orderIds, status, token) =>
  axios
    .put(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/admin/pickup-order/status`,
      { order_ids: orderIds, status: Number(status) },
      { headers: adminHeaders(token) },
    )
    .then((res) => res.data);

export const getServicePartners = (
  partnerName,
  mobileNumber,
  page,
  recordsPerPage,
  obj,
  status,
  type,
) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/service-partners", {
      params: {
        partner_name: partnerName || "",
        mobile_number: mobileNumber || "",
        page: page || 1,
        records_per_page: recordsPerPage,
        is_active: status === "0" || status === "1" ? status : "",
        type: type || "",
      },
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const getServicePartnerNames = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/service-partners/names", {
      headers: adminHeaders(obj),
    })
    .then((res) => res.data);
};
export const getServicePartner = (id, obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + "/service-partners/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const partnerPayload = (partner) => {
  const mobileNumber = partner.mobile.replace(/\D/g, "");
  return {
    mobile_number: mobileNumber ? "+94" + mobileNumber : "",
    latitude: Number(partner.latitude),
    longitude: Number(partner.longitude),
    branch_name: partner.branchName,
    district: Number(partner.district),
    partner_name: partner.name,
    is_active: !Boolean(partner.isInactive),
    quote_available: Boolean(partner.quoteAvailable),
    logo: partner.logo || null,
    partner_features: (partner.partnerFeatures || [])
      .filter((feature) => feature && feature.type)
      .map((feature) => ({
        type: feature.type,
        subtypes: Array.isArray(feature.subtypes) ? [...feature.subtypes] : [],
      })),
  };
};

export const uploadServicePartnerLogo = (file, obj) => {
  const formData = new FormData();
  formData.append("logo", file);

  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/service-partners/upload/logo",
      formData,
      {
        headers: {
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => res.data)
    .catch((error) => {
      const status = error && error.response && error.response.status;

      if (status >= 500) {
        throw new Error(
          "Unable to upload the partner logo. Please try again.",
        );
      }

      throw error;
    });
};

export const createServicePartner = (partner, obj) => {
  return axios
    .post(
      process.env.REACT_APP_NOT_SECRET_CODE + "/service-partners",
      partnerPayload(partner),
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const updateServicePartner = (id, partner, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE + "/service-partners/" + id,
      partnerPayload(partner),
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      },
    )
    .then((res) => {
      return res.data;
    });
};

export const deleteServicePartner = (id, obj) => {
  return axios
    .delete(process.env.REACT_APP_NOT_SECRET_CODE + "/service-partners/" + id, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const updateServicePartnerStatus = (id, isActive, obj) => {
  return axios
    .put(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/service-partners/" +
        id +
        "/status",
      { is_active: isActive },
      { headers: adminHeaders(obj) },
    )
    .then((res) => res.data);
};
